export default __webpack_public_path__ + "static/fin-ins-op-pred-ana-abd91414094387f4c22609958120f886.png";